import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const DashboardFooter = () => {
  const { t } = useTranslation();
  const currentYear = new Date()?.getFullYear();

  const footerLinks = [
    {
      id: 'privacy',
      label: t('footer.privacy'),
      path: '/legal-page'
    },
    {
      id: 'terms',
      label: t('footer.terms'),
      path: '/legal-page'
    },
    {
      id: 'contact',
      label: t('footer.contact'),
      path: '/contact'
    }
  ];

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-text">
          <p>© {currentYear} OrizonDesk. {t('footer.rights')}</p>
          <p className="text-xs mt-1">{t('footer.gdpr_text')}</p>
        </div>

        <nav className="footer-links" role="navigation">
          {footerLinks?.map((link) => (
            <Link
              key={link?.id}
              to={link?.path}
              className="footer-link"
            >
              {link?.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
};

export default DashboardFooter;